export type CatalogArtworkKind = 'tote' | 'frame' | 'jewelry' | 'shirt' | 'mug'

export function catalogArtworkKind(category: string): CatalogArtworkKind {
  const value = category.toLowerCase()
  if (value.includes('leather') || value.includes('bag')) return 'tote'
  if (value.includes('wood') || value.includes('art')) return 'frame'
  if (value.includes('jewel') || value.includes('silver')) return 'jewelry'
  if (value.includes('apparel') || value.includes('accessor')) return 'shirt'
  return 'mug'
}

export function catalogArtworkSurface(category: string) {
  const kind = catalogArtworkKind(category)
  if (kind === 'tote') return 'bg-[#ebe5dc]'
  if (kind === 'frame') return 'bg-[#e7edf0]'
  if (kind === 'jewelry') return 'bg-[#eee6df]'
  if (kind === 'shirt') return 'bg-[#e5ece8]'
  return 'bg-[#ece9e2]'
}
